import { render, staticRenderFns } from "./Authorgarden.vue?vue&type=template&id=264328ef&scoped=true&"
import script from "./Authorgarden.vue?vue&type=script&lang=js&"
export * from "./Authorgarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264328ef",
  null
  
)

export default component.exports